@use '../common/colors.scss' as colors;

.faq {
  .header-buttons {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 20px 20px 0px;
    font-weight: 500;
    font-size: 14px;
    color: colors.$blue;

    .modal-close {
      background: none;
      border: none;
    }

    .faq-back {
      cursor: pointer;
      color: colors.$blue;
      border: none;
      background-color: inherit;
      padding: 0;
      font-weight: 500;

      span {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 14px;
        color: colors.$blue;
      }
    }
  }

  .header-txt {
    padding-bottom: 12px;

    h1 {
      text-align: center;
      font-weight: 500;
      font-size: 23px;
      color: colors.$surface-light-text-primary;
      margin-top: 36px;
      margin-bottom: 24px;
    }
    .margin-bot-66 {
      margin-bottom: 66px;
    }
    .margin-bot-110 {
      margin-bottom: 110px;
    }
    .faq-tabs {
      margin-bottom: 36px;
      padding: 0px 24px;

      .faq-tab {
        font-size: 16px;

        color: colors.$surface-light-text-primary;
        padding-bottom: 9px;
        text-decoration: none;
        font-weight: 300;
        display: inline-block;
        cursor: pointer;
        background: none;
        border: none;
      }

      a {
        line-height: 19px;
      }

      .faq-tab:first-child {
        margin-right: 34px;
      }
      .faq-tab-active {
        border-bottom: 3px solid colors.$teal;
        transition: border-width 0.2s linear;
        color: colors.$surface-light-text-primary;
        font-weight: 500;
      }
    }
  }

  .faq-body {
    padding: 0px 24px;

    > div {
      box-shadow: none;
      border-radius: 0px;
      margin: 0px;
      border: none;
      border-top: 1px solid colors.$flexpay-border;
    }

    .faq-title {
      margin: 4px 0px;
      font-weight: 500;
    }
    a {
      text-decoration: underline;
    }
  }

  .more-questions {
    margin-top: 16px;
    margin-bottom: 175px;
    text-align: center;
    text-decoration: underline;
    font-weight: 500;

    a {
      text-decoration: underline;
    }
  }

  .language-toggle-wrapper {
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;

    .language-toggle {
      justify-content: center;
    }
  }
  .MuiButtonBase-root.MuiAccordionSummary-root {
    font-weight: 500;
  }

  .faq-accordian-details {
    :global(.MuiAccordionDetails-root) {
      display: inline-block;
      font-size: 14px;
      line-height: 20px;
      color: colors.$body-text;
    }
  }
  strong {
    font-weight: 500;
  }

  div.MuiAccordion-root:before {
    background-color: transparent;
  }

  .MuiPaper-root:last-child {
    border-bottom: 1px solid colors.$flexpay-border;
  }
}

:global(.flexpay) {
  .header-txt {
    h1 {
      color: colors.$flexpay-text;
      font-size: 26px;
    }
    .faq-tabs .faq-tab-active {
      border-bottom-color: colors.$flexpay-link;
    }
  }

  .faq-body {
    > div {
      .MuiAccordionSummary-content {
        color: colors.$flexpay-text;
        line-height: 24px;
      }
      .MuiAccordionDetails-root {
        color: colors.$flexpay-body-text;
        font-size: 14px;
        line-height: 24px;
      }
    }

    .faq-title {
      margin: 4px 0px;
    }
    a {
      text-decoration: underline;
    }

    b {
      font-weight: 500;
    }
  }

  .more-questions {
    text-decoration: none;
    a {
      color: colors.$flexpay-links-primary;
      line-height: 24px;
      text-decoration: none;
    }
  }
}
